<template>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label for="name">Nama Kategori </label>
                <input type="text" v-model="model.name" class="form-control" readonly>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="icon">Icon </label>
                <input type="text" v-model="model.icon" class="form-control" readonly>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label for="description">Deskripsi </label>
                <input type="text" v-model="model.description" class="form-control" readonly>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    components: {},
    props: {
        detail: {
            type: Object,
            default: () => ({
                name: '',
                id: '',
                icon: '',
                description: '',
            })
        }
    },
    data() {
        return {
            model: {
                id: this.detail?.id,
                name: this.detail?.name,
                icon: this.detail?.icon,
                description: this.detail?.description,
            }
        }
    },
    methods: {
        resetModel() {
            this.model = { name: '', id: '', icon: '', description: '', }
        }
    },
    watch: {
        detail: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.model = {
                    name: newVal?.name || '',
                    id: newVal?.id || '',
                    icon: newVal?.icon || '',
                    description: newVal?.description || '',
                }
            }
        }
    }
}
</script>